import { render, staticRenderFns } from "./PostIndexPagination.vue?vue&type=template&id=06d8e240&"
import script from "./PostIndexPagination.vue?vue&type=script&lang=js&"
export * from "./PostIndexPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports